import React from 'react'
import videoPlayer from '../assets/video-player.png';


const Productsdiv3 = (props) => {
  return (
    <div>
       <div className="py-5 text-start" style={{ backgroundColor: '#00b8f1' }}>
        <div className="container-lg">
          <div className="row align-items-center">
            <div className="col-md-6 text-white mb-4 mb-md-0">
              <p className="text-uppercase fw-semibold">
               {props.smallHeading}
              </p>
              <h2 className="fw-bold mb-3">
                {props.largeHeading}
              </h2>
              <p className="fw-light">
                {props.lightHeading}
              </p>
             <a
  href="https://wa.me/+919871115060"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-success d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold rounded-pill mt-4" 
  data-bs-toggle="tooltip"
  data-bs-placement="top"
  data-bs-title="Chat with us on WhatsApp"
  style={{ fontSize: '1.1rem' }}
>
  <i className="fab fa-whatsapp fa-lg"></i>
  Contact Us
</a>

            </div>

            <div className="col-md-6 text-center">
              <img
                src={props.imagesrc} 
                alt="Video Player"
                className="img-fluid"
                style={{ maxHeight: '350px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Productsdiv3
